/* TANTRUMS 2026 — storefront behaviour */
(function () {
  'use strict';

  /* ---- Hero crossfade ---- */
  var frames = document.querySelectorAll('.tt-hero-frame');
  if (frames.length > 1) {
    var f = 0;
    setInterval(function () {
      frames[f].classList.remove('on');
      f = (f + 1) % frames.length;
      frames[f].classList.add('on');
    }, 4000);
  }

  /* ---- Product: variant selection ---- */
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var data = JSON.parse(document.getElementById('tt-variants').textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var atc = form.querySelector('.tt-atc');
    var colorEl = document.querySelector('[data-color-name]');

    function selected(group) {
      var el = document.querySelector('[data-opt="' + group + '"][aria-pressed="true"]');
      return el ? el.dataset.value : null;
    }

    function match() {
      var c = selected('color'), s = selected('size');
      return data.find(function (v) {
        return (c === null || v.color === c) && (s === null || v.size === s);
      });
    }

    function refresh() {
      var v = match();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      var out = !v.available;
      atc.disabled = out;
      atc.textContent = out ? 'Sold out' : 'Add to cart';

      /* grey out sizes with no stock in the chosen colour */
      var c = selected('color');
      document.querySelectorAll('[data-opt="size"]').forEach(function (b) {
        var hit = data.find(function (v2) {
          return v2.size === b.dataset.value && (c === null || v2.color === c);
        });
        b.disabled = !hit || !hit.available;
      });
    }

    document.querySelectorAll('[data-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.dataset.opt;
        document.querySelectorAll('[data-opt="' + group + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        if (group === 'color') {
          if (colorEl) colorEl.textContent = btn.dataset.value;
          var g = document.querySelector('[data-gallery]');
          if (g) {
            g.querySelectorAll('[data-shot-color]').forEach(function (img) {
              var m = img.dataset.shotColor === '' || img.dataset.shotColor === btn.dataset.value;
              img.hidden = !m;
            });
          }
        }
        refresh();
      });
    });

    refresh();
  }

  /* ---- Size chart link opens the accordion ---- */
  var link = document.querySelector('.tt-size-link');
  if (link) {
    link.addEventListener('click', function () {
      var d = document.getElementById(link.dataset.chart);
      if (!d) return;
      d.open = true;
      d.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---- Region gate: Canada only, once per session ---- */
  var gate = document.getElementById('tt-gate');
  if (gate) {
    var KEY = 'tantrums-region';
    var seen = null;
    try { seen = sessionStorage.getItem(KEY); } catch (e) {}

    function remember(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }
    function close() { gate.hidden = true; document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') { remember('stay'); close(); } }

    if (!seen && gate.dataset.country === 'CA') {
      gate.hidden = false;
      document.addEventListener('keydown', onKey);
    }
    var stay = document.getElementById('tt-gate-stay');
    if (stay) stay.addEventListener('click', function () { remember('stay'); close(); });
    var go = document.getElementById('tt-gate-go');
    if (go) go.addEventListener('click', function () { remember('ca'); });
    gate.addEventListener('click', function (e) {
      if (e.target === gate) { remember('stay'); close(); }
    });
  }
})();
